// Coupons API Service
// Based on Zclub Kupon API Documentation
import AsyncStorage from '@react-native-async-storage/async-storage';
import { handleApiResponse } from './userDataService';
import { makeAuthenticatedApiCall, getSessionId, getRememberToken } from './authApi';

// Debug function to check session state
export const debugSessionState = async () => {
  try {
    const sessionId = await getSessionId();
    const rememberToken = await getRememberToken();
    const allKeys = await AsyncStorage.getAllKeys();
    const sessionKeys = allKeys.filter(key => key.includes('session') || key.includes('token') || key.includes('user'));
    
    console.log('=== BANNER SESSION DEBUG INFO ===');
    // console.log('Session ID:', sessionId);
    // console.log('Remember Token:', rememberToken ? 'Present' : 'Missing');
    // console.log('Relevant AsyncStorage keys:', sessionKeys);
    
    if (sessionKeys.length > 0) {
      const values = await AsyncStorage.multiGet(sessionKeys);
      // console.log('AsyncStorage values:', values);
    }
    
    return {
      sessionId,
      rememberToken,
      hasSession: !!sessionId,
      hasRememberToken: !!rememberToken,
      storageKeys: sessionKeys
    };
  } catch (error) {
    console.error('Error debugging session state:', error);
    return null;
  }
};

import { ZCLUB_API_URL, API_BASE_URL } from '../config/api';

const ZCLUB_BASE_URL = ZCLUB_API_URL;

// Get active ig banner
export const getIGBanner = async () => {
  try {
    console.log('getIGBanner called');
    
    // Debug session state first
    await debugSessionState();
    
    const url = `${ZCLUB_BASE_URL}/banner-ig`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const result = await response.json();
    console.log('getIGBanner API call successful');
    return result;
  } catch (error) {
    console.error('getIGBanner API call failed:', error);
    throw new Error(error.message || 'Failed to fetch IG banners');
  }
};

// Helper function to format banner data for display
export const formatIGBannerForDisplay = (banner) => {
  if (!banner || !banner.path) return null;
  return {
    id: banner.id,
    title: banner.subjudul,
    logo: banner.brand?.thumbnail,
    background: banner.path,
    urls: Array.isArray(banner.links) ? banner.links.map((url) => ({
      type: url.social_media,
      title: url.judul_link,
      url: url.link,
    })) : [],
  };
};

export default {
  getIGBanner,
  formatIGBannerForDisplay,
};